export const defaultFormItems = [
  {
    type: "input",
    prop: "name",
    label: "姓名",
    labelWidth: "56px",
    rules: [
      {
        required: true,
        message: "请检查必填项",
        trigger: ["blur", "change"],
      },
    ],
    colAttrs: { span: 12 },
  },
  {
    type: "input",
    prop: "idCard",
    label: "身份证号",
    labelWidth: "84px",
    rules: [
      {
        required: true,
        message: "请检查必填项",
        trigger: ["blur", "change"],
      },
      {
        pattern:
          /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
        message: "请输入正确的身份证号",
        trigger: ["blur", "change"],
      },
    ],
    colAttrs: { span: 12 },
  },
  {
    type: "select",
    prop: "gender",
    label: "性别",
    labelWidth: "56px",
    rules: [
      {
        required: true,
        message: "请检查必填项",
        trigger: ["blur", "change"],
      },
    ],
    options: [
      { label: "男", value: "1" },
      { label: "女", value: "2" },
    ],
    colAttrs: { span: 12 },
  },

  {
    type: "select",
    prop: "postId",
    label: "报考岗位",
    labelWidth: "84px",
    rules: [
      {
        required: true,
        message: "请检查必填项",
        trigger: ["blur", "change"],
      },
    ],
    options: [],
    colAttrs: { span: 12 },
  },
  // 岗位代码：由所选「报考岗位」自动回填，考生不可编辑
  {
    type: "input",
    prop: "postCode",
    label: "岗位代码",
    labelWidth: "84px",
    otherOptions: { disabled: true, placeholder: "选择报考岗位后自动带出" },
    colAttrs: { span: 12 },
  },
  // 联系电话：固定默认报名字段（与姓名/身份证号同级，不再依赖报名字典/表单配置）
  {
    type: "input",
    prop: "phone",
    label: "联系电话",
    labelWidth: "84px",
    rules: [
      {
        required: true,
        message: "请检查必填项",
        trigger: ["blur", "change"],
      },
      {
        pattern: /^1[3-9]\d{9}$/,
        message: "请输入正确的联系电话",
        trigger: ["blur", "change"],
      },
    ],
    colAttrs: { span: 12 },
  },
  {
    slotName: "regRequirement",
    type: "editor",
    prop: "regRequirement",
    label: "报名要求",
    colAttrs: { span: 24 },
  },
];
